export class PhotoService {
  constructor($http) {
    this.http = $http;
  }

  getUniqNum() {
    return (String(Math.random()).toString()).replace("0.", "");
  }

  setAvatarFeedbackStatus(params) {
    return this.http.get(`/api/photo/avatar-feedback/${params.id}/${params.val}?${this.getUniqNum()}`);
  }

  approveAvatar(obj) {
    return this.http.get(`/api/photo/approve-avatar/${obj.id}/${obj.checked}?${this.getUniqNum()}`);
  }

  rejectAvatar(obj) {
    return this.http.post(`/api/photo/reject-avatar/?${this.getUniqNum()}`, obj);
  }

  changeAvatar(params) {
    return this.http.post(`/api/photo/change-avatar`, params);
  }

  updateAvatar(params) {
    return this.http.post(`/api/photo/update-avatar/`, params);
  }

  approvePhoto(params) {
    return this.http.post(`/api/photo/approve-photo/`, params);
  }

  rejectPhoto(params) {
    return this.http.post(`/api/photo/reject-photo/`, params);
  }

  editAlbumPhoto(params) {
    return this.http.post(`/api/photo/albumphoto`, params)
  }

  updateAlbumPhoto(params) {
    return this.http.put(`/api/photo/albumphoto`, params)
  }
}
